import { useDispatch, useSelector } from "react-redux";

import { ELEMENT_STATUS, ENTITY, TAB_STATUSES } from "../../constants";
import { useEventListeners, useUnload, useUrlParams } from "../../hooks";
import { resetCurrentSelectedItems, resetVisualBuilderData, setVisualBuilderValues } from "../../store/actions";
import { contentElementsSelector, currentMediaItemSelector, elementsSelector } from "../../store/selectors";
import { deleteContentElement, deleteElement } from "../../utils/element";

export function useVisualBuilderListeners() {
  const dispatch = useDispatch();

  const params = useUrlParams();
  const { propertyId, experienceId, userId, tabStatus } = params;

  const {
    mediaItem: { id: mediaItemId },
  } = useSelector(currentMediaItemSelector);

  const { elements } = useSelector(elementsSelector(propertyId, experienceId));
  const { elements: contentElements } = useSelector(contentElementsSelector(propertyId, mediaItemId));

  let entities = [
    { name: ENTITY.PROPERTY, options: {} },
    { name: ENTITY.MEDIA_ITEM, options: { propertyId } },
    { name: ENTITY.EXPERIENCE, options: { propertyId } },
    { name: ENTITY.CONTENT_TYPE, options: { propertyId } },
    { name: ENTITY.TAG, options: { propertyId } },
    { name: ENTITY.CONTENT_ELEMENT, options: { propertyId } },
  ];

  if (userId) {
    entities = [
      ...entities,
      { name: ENTITY.USER, options: {} },
      { name: ENTITY.NOTIFICATION, options: {} },
      { name: ENTITY.MEMBER, options: { propertyId } },
      { name: ENTITY.SHARE, options: { propertyId } },
      { name: ENTITY.FAVORITE, options: { propertyId } },
      { name: ENTITY.FLAG, options: {} },
      { name: ENTITY.ICON, options: { propertyId } },
    ];
  }

  if (experienceId) {
    entities.push({ name: ENTITY.EXPERIENCE_ASSET_CATEGORY, options: { propertyId, experienceId } });
    entities.push({ name: ENTITY.EXPERIENCE_MEDIA_ITEM, options: { propertyId, experienceId } });
    entities.push({ name: ENTITY.EXPERIENCE_CONTENT_TYPE, options: { propertyId, experienceId } });
    entities.push({ name: ENTITY.EXPERIENCE_TAG, options: { propertyId, experienceId } });
    entities.push({ name: ENTITY.ELEMENT, options: { propertyId, experienceId } });
    entities.push({ name: ENTITY.HOTSPOT, options: { propertyId, experienceId } });
  }

  useEventListeners({ entities });

  useUnload(() => {
    dispatch(setVisualBuilderValues(propertyId, "prevTabStatus", null));
    if (
      propertyId &&
      [TAB_STATUSES.HOMEBASE, TAB_STATUSES.COLLECT, TAB_STATUSES.CUSTOMIZE, TAB_STATUSES.SHARE].includes(tabStatus)
    ) {
      dispatch(resetVisualBuilderData(params));
    }

    dispatch(resetCurrentSelectedItems());

    const promises = [];
    if (elements.length) {
      elements.forEach((element) => {
        if (element.status === ELEMENT_STATUS.DRAFT) {
          promises.push(deleteElement(propertyId, element.experienceId, element.id));
        }
      });
    }

    if (contentElements.length) {
      contentElements.forEach((element) => {
        if (element.status === ELEMENT_STATUS.DRAFT) {
          promises.push(deleteContentElement(propertyId, element.mediaItemId, element.id));
        }
      });
    }

    if (promises.length) {
      Promise.all(promises).then();
    }
  });
}
